export default "__VITE_ASSET__286929c5__"